export default {
  fields: {
    "Custom HTML": { value: "<hr/><h3>Lorum Ipsum - mock</h3><hr/>" },
  },
};
